module.exports = __webpack_public_path__ + "assets/img/advanced-arrows.73153b06.svg";